// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uGlq","title":"Header_title__3TBXm","left":"Header_left__3XVuL","clinicName":"Header_clinicName__37AYM"};